export const IconClear = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="18 24 39 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.5282 42.9497L42.5784 38L47.5282 33.0502L44.9497 30.4718L40 35.4216L35.0502 30.4718L32.4718 33.0502L37.4216 38L32.4718 42.9497L35.0502 45.5282L40 40.5784L44.9497 45.5282L47.5282 42.9497ZM18.0147 41.5355L26.9646 50.4854C28.0683 51.589 29 52 31 52L52 52C54.7614 52 57 49.7614 57 47L57 29C57 26.2386 54.7614 24 52 24L31 24C29 24 28.0683 24.4113 26.9646 25.5149L18.0147 34.4645C16.0621 36.4171 16.0621 39.5829 18.0147 41.5355ZM31 49C30 49 29.6048 48.8828 29.086 48.3641L20.1361 39.4142C19.355 38.6332 19.355 37.3669 20.1361 36.5858L29.086 27.6362C29.6048 27.1175 30 27 31 27.0001L52 27.0001C53.1046 27.0001 54 27.8955 54 29.0001L54 47.0001C54 48.1046 53.1046 49.0001 52 49.0001L31 49Z"
        fill={color}
      />
    </svg>
  );
};
